<div class="main-layout">
  <app-header-home></app-header-home>
  <main class="content">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>